"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var joi_1 = __importDefault(require("@hapi/joi"));

var editable_parsed_variable_text_component_1 = __importDefault(require("../editable-parsed-variable-text/editable-parsed-variable-text.component"));

var editable_text_option_view_styles_1 = require("./editable-text-option-view.styles");
/* validation
----------------------------------*/


var LABEL_MAX_LENGTH = 500; // line messaging api 的には無制限。

var ERROR_MESSAGE = "1\u6587\u5B57\u4EE5\u4E0A".concat(LABEL_MAX_LENGTH, "\u6587\u5B57\u4EE5\u4E0B\u306E\u5024\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");

exports.isValidLable = function (parsedText) {
  var schema = joi_1.default.string().max(LABEL_MAX_LENGTH).required();

  var _schema$validate = schema.validate(parsedText),
      error = _schema$validate.error;

  return {
    error: error ? ERROR_MESSAGE : null
  };
};

var EditableTextOptionView = function EditableTextOptionView(_ref) {
  var option = _ref.option,
      updateLable = _ref.updateLable;
  return react_1.default.createElement(editable_text_option_view_styles_1.ParagraphWrapperDiv, null, react_1.default.createElement(editable_parsed_variable_text_component_1.default, {
    rawText: option.label,
    handleSavedRawText: updateLable,
    validate: exports.isValidLable
  }));
};

exports.default = EditableTextOptionView;